// src/components/AppLayout/views/FoodView.tsx
import React from "react";
import { Typography, Box } from "@mui/material";

const FoodView: React.FC = () => {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4">Food</Typography>
      <Typography>Place orders for food items.</Typography>
    </Box>
  );
};

export default FoodView;
